import * as React from "react";

function SvgDownRight(props) {
  return <svg data-name="Calque 1" viewBox="0 0 26.77 15.49" width="1em" height="1em" {...props}><path d="M15.44.42a2.09 2.09 0 01.49.4l10.56 12.53c1.08 1.26-1.19 2.58-3.37 2L1.44 9.24A2.94 2.94 0 01.75 9c-1-.56-1-1.48 0-2.08l5.56-3.27L11.87.42a4 4 0 013.57 0z" fill="#153042" /></svg>;
}

export default SvgDownRight;